import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="live-map-demo-form"
export default class extends Controller {
  async submit (event) {
    event.preventDefault()

    const formData = new FormData(this.element)
    const json = this.convertFormDataToJSON(formData)
    this.dispatch('update', { detail: json })
  }

  // Converts rails form data to JSON
  //
  // e.g. device[position][latitude] => { device: { position: { latitude: ... } } }
  convertFormDataToJSON (formData) {
    const json = {}

    // Build the nested structure
    for (const [key, value] of formData.entries()) {
      const keys = key.split('[').map(k => k.replace(']', ''))
      this._assignNestedValue(json, keys, value)
    }

    // Add last_timestamp for compatibility with status updates
    json.meta = json.meta || {}
    json.meta.last_timestamp = parseInt(Date.now())

    return json
  }

  _assignNestedValue (obj, keys, value) {
    const lastKey = keys.pop()
    let current = obj

    for (const key of keys) {
      if (!current[key]) {
        current[key] = {}
      }
      current = current[key]
    }

    // Trim whitespace and convert empty strings to null
    value = value.trim()
    if (value === '') {
      value = null
    }

    current[lastKey] = value
  }
}
